import React from "react";
import * as Icons from "react-feather";
import { TextingStatusIcon } from "shared/texting-status";

const icons: Record<TextingStatusIcon, Icons.Icon> = {
	clock: Icons.Clock,
	alert: Icons.AlertTriangle,
	check: Icons.CheckCircle,
	paused: Icons.XCircle,
};

interface Props {
	icon: TextingStatusIcon;
	/** Figma's Active chip shows a plain check; its banner shows the circled one. */
	tag?: boolean;
	className?: string;
}

export const StatusIcon: React.FC<Props> = ({ icon, tag = false, className }) => {
	const Icon = icon === "check" && tag ? Icons.Check : icons[icon];
	return <Icon size={16} className={className} aria-hidden="true" />;
};
